import { render, staticRenderFns } from "./inventoryBinBatchDialog.vue?vue&type=template&id=27fdf0c4&"
import script from "./inventoryBinBatchDialog.vue?vue&type=script&lang=js&"
export * from "./inventoryBinBatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports